// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Version History Styles */
.version-history-modal .modal-body {
  padding: 0;
}

.version-history-container {
  padding: 24px;
}

.version-controls {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.version-list {
  flex: 0 0 250px;
  border-right: 1px solid #eee;
  padding-right: 20px;
  max-height: 60vh;
  overflow-y: auto;
}

.version-item {
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 10px;
  cursor: pointer;
  background-color: #f8f9fa;
  border: 1px solid #eee;
  transition: all 0.2s ease;
}

.version-item:hover {
  background-color: #f0f7ff;
  border-color: #d0e8ff;
}

.version-item.selected {
  background-color: #e6f7ff;
  border: 1px solid #91d5ff;
}

.badge {
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 0.7rem;
  font-weight: 500;
}

.badge.auto {
  background-color: #e6f7ff;
  color: #1890ff;
}

.badge.manual {
  background-color: #f6ffed;
  color: #52c41a;
}

.badge.creation {
  background-color: #fff7e6;
  color: #fa8c16;
}

.version-detail-panel {
  flex: 1 1;
  padding-left: 20px;
}

.version-details h3,
.version-comparison h3 {
  margin: 0 0 16px 0;
  font-size: 1.1rem;
  color: #333;
}

.version-metadata,
.comparison-metadata {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
  background-color: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
}

.metadata-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.metadata-label {
  font-size: 0.8rem;
  color: #666;
}

.metadata-value {
  font-size: 0.9rem;
  font-weight: 500;
}

.change-type-auto {
  color: #1890ff;
}

.change-type-manual {
  color: #52c41a;
}

.change-type-creation {
  color: #fa8c16;
}

.version-changes {
  margin-bottom: 24px;
}

.version-changes h4,
.version-content h4 {
  margin: 0 0 12px 0;
  font-size: 1rem;
  color: #333;
}

.version-content {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
}

.version-content-section {
  width: 100%;
  margin-bottom: 16px;
}

.version-description {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.6;
  color: #333;
  white-space: pre-wrap;
}

.version-content-section h5 {
  margin: 0 0 8px 0;
  font-size: 0.9rem;
  color: #333;
}

.version-content-section pre {
  background-color: #f8f9fa;
  padding: 12px;
  border-radius: 6px;
  font-family: monospace;
  white-space: pre-wrap;
  font-size: 0.9rem;
  margin: 0;
}

.comparison-content {
  margin-top: 24px;
}

.comparison-content h4 {
  margin: 0 0 12px 0;
  font-size: 1rem;
  color: #333;
}

.comparison-row {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.comparison-column {
  flex: 1 1;
}

.comparison-column pre {
  background-color: #f8f9fa;
  padding: 12px;
  border-radius: 6px;
  font-family: monospace;
  white-space: pre-wrap;
  font-size: 0.9rem;
  margin: 0;
  min-height: 100px;
}

.comparison-column pre.highlight-changes {
  background-color: #f6ffed;
  border-left: 3px solid #52c41a;
}

.empty-selection {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  color: #666;
  font-style: italic;
}

/* Auto Update Modal Styles */
.auto-update-modal .modal-body {
  padding: 0;
}

.test-case-info {
  margin-bottom: 24px;
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.detected-changes {
  margin-bottom: 24px;
}

.change-item {
  padding: 16px;
  margin-bottom: 16px;
  border-radius: 8px;
  border: 1px solid #eee;
  background-color: white;
  position: relative;
  transition: all 0.2s ease;
}

.change-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.change-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.change-select {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.change-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.old-value {
  background-color: #fff1f0;
  padding: 12px;
  border-radius: 6px;
  font-size: 0.9rem;
}

.new-value {
  background-color: #f6ffed;
  padding: 12px;
  border-radius: 6px;
  font-size: 0.9rem;
}

.affected-step {
  font-size: 0.85rem;
  color: #666;
  margin-top: 4px;
}

/* Review Panel Styles */
.review-panel-modal .modal-body {
  padding: 0;
}

.review-tabs {
  display: flex;
  border-bottom: 1px solid #e9ecef;
  padding: 0 24px;
  background-color: #f8f9fa;
}

.tab-button {
  padding: 12px 24px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  font-size: 0.9rem;
  font-weight: 500;
  color: #6c757d;
  cursor: pointer;
  transition: all 0.2s ease;
}

.tab-button.active {
  color: #007bff;
  border-bottom-color: #007bff;
}

.assign-reviewers-tab,
.add-review-tab,
.review-history-tab {
  padding: 24px;
}

.reviewer-item {
  padding: 16px;
  margin-bottom: 12px;
  border-radius: 8px;
  border: 1px solid #eee;
  background-color: white;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.reviewer-item:hover {
  background-color: #f0f7ff;
  border-color: #d0e8ff;
}

.reviewer-item.selected {
  background-color: #e6f7ff;
  border: 1px solid #91d5ff;
}

.reviewer-avatar {
  font-size: 1.5rem;
  margin-right: 16px;
}

.reviewer-info {
  flex: 1 1;
}

.reviewer-name {
  font-weight: 500;
  font-size: 1rem;
}

.reviewer-role,
.reviewer-email {
  font-size: 0.8rem;
  color: #666;
}

.review-form .form-group {
  margin-bottom: 16px;
}

.review-form label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
}

.review-item {
  padding: 16px;
  margin-bottom: 16px;
  border-radius: 8px;
  border: 1px solid #eee;
  background-color: white;
  border-left-width: 4px;
}

.review-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}

.reviewer-info {
  display: flex;
  align-items: center;
}

.review-date {
  font-size: 0.8rem;
  color: #666;
}

.review-status {
  padding: 4px 12px;
  border-radius: 12px;
  font-weight: 500;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  gap: 4px;
}

.review-comments {
  font-size: 0.9rem;
  line-height: 1.5;
}

.update-options {
  margin-bottom: 24px;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
}

textarea {
  width: 100%;
  padding: 12px;
  border-radius: 6px;
  border: 1px solid #ddd;
  min-height: 80px;
  font-size: 0.9rem;
  resize: vertical;
}

/* Animation for loading spinner */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/version-history.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* Version History Styles */\n.version-history-modal .modal-body {\n  padding: 0;\n}\n\n.version-history-container {\n  padding: 24px;\n}\n\n.version-controls {\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.version-list {\n  flex: 0 0 250px;\n  border-right: 1px solid #eee;\n  padding-right: 20px;\n  max-height: 60vh;\n  overflow-y: auto;\n}\n\n.version-item {\n  padding: 12px;\n  border-radius: 6px;\n  margin-bottom: 10px;\n  cursor: pointer;\n  background-color: #f8f9fa;\n  border: 1px solid #eee;\n  transition: all 0.2s ease;\n}\n\n.version-item:hover {\n  background-color: #f0f7ff;\n  border-color: #d0e8ff;\n}\n\n.version-item.selected {\n  background-color: #e6f7ff;\n  border: 1px solid #91d5ff;\n}\n\n.badge {\n  padding: 2px 6px;\n  border-radius: 10px;\n  font-size: 0.7rem;\n  font-weight: 500;\n}\n\n.badge.auto {\n  background-color: #e6f7ff;\n  color: #1890ff;\n}\n\n.badge.manual {\n  background-color: #f6ffed;\n  color: #52c41a;\n}\n\n.badge.creation {\n  background-color: #fff7e6;\n  color: #fa8c16;\n}\n\n.version-detail-panel {\n  flex: 1;\n  padding-left: 20px;\n}\n\n.version-details h3,\n.version-comparison h3 {\n  margin: 0 0 16px 0;\n  font-size: 1.1rem;\n  color: #333;\n}\n\n.version-metadata,\n.comparison-metadata {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 24px;\n  background-color: #f8f9fa;\n  padding: 16px;\n  border-radius: 8px;\n}\n\n.metadata-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.metadata-label {\n  font-size: 0.8rem;\n  color: #666;\n}\n\n.metadata-value {\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.change-type-auto {\n  color: #1890ff;\n}\n\n.change-type-manual {\n  color: #52c41a;\n}\n\n.change-type-creation {\n  color: #fa8c16;\n}\n\n.version-changes {\n  margin-bottom: 24px;\n}\n\n.version-changes h4,\n.version-content h4 {\n  margin: 0 0 12px 0;\n  font-size: 1rem;\n  color: #333;\n}\n\n.version-content {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  width: 100%;\n}\n\n.version-content-section {\n  width: 100%;\n  margin-bottom: 16px;\n}\n\n.version-description {\n  margin: 0;\n  font-size: 0.9rem;\n  line-height: 1.6;\n  color: #333;\n  white-space: pre-wrap;\n}\n\n.version-content-section h5 {\n  margin: 0 0 8px 0;\n  font-size: 0.9rem;\n  color: #333;\n}\n\n.version-content-section pre {\n  background-color: #f8f9fa;\n  padding: 12px;\n  border-radius: 6px;\n  font-family: monospace;\n  white-space: pre-wrap;\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n.comparison-content {\n  margin-top: 24px;\n}\n\n.comparison-content h4 {\n  margin: 0 0 12px 0;\n  font-size: 1rem;\n  color: #333;\n}\n\n.comparison-row {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.comparison-column {\n  flex: 1;\n}\n\n.comparison-column pre {\n  background-color: #f8f9fa;\n  padding: 12px;\n  border-radius: 6px;\n  font-family: monospace;\n  white-space: pre-wrap;\n  font-size: 0.9rem;\n  margin: 0;\n  min-height: 100px;\n}\n\n.comparison-column pre.highlight-changes {\n  background-color: #f6ffed;\n  border-left: 3px solid #52c41a;\n}\n\n.empty-selection {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 200px;\n  color: #666;\n  font-style: italic;\n}\n\n/* Auto Update Modal Styles */\n.auto-update-modal .modal-body {\n  padding: 0;\n}\n\n.test-case-info {\n  margin-bottom: 24px;\n  padding: 16px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n}\n\n.detected-changes {\n  margin-bottom: 24px;\n}\n\n.change-item {\n  padding: 16px;\n  margin-bottom: 16px;\n  border-radius: 8px;\n  border: 1px solid #eee;\n  background-color: white;\n  position: relative;\n  transition: all 0.2s ease;\n}\n\n.change-item:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.change-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 12px;\n}\n\n.change-select {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.change-details {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.old-value {\n  background-color: #fff1f0;\n  padding: 12px;\n  border-radius: 6px;\n  font-size: 0.9rem;\n}\n\n.new-value {\n  background-color: #f6ffed;\n  padding: 12px;\n  border-radius: 6px;\n  font-size: 0.9rem;\n}\n\n.affected-step {\n  font-size: 0.85rem;\n  color: #666;\n  margin-top: 4px;\n}\n\n/* Review Panel Styles */\n.review-panel-modal .modal-body {\n  padding: 0;\n}\n\n.review-tabs {\n  display: flex;\n  border-bottom: 1px solid #e9ecef;\n  padding: 0 24px;\n  background-color: #f8f9fa;\n}\n\n.tab-button {\n  padding: 12px 24px;\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #6c757d;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.tab-button.active {\n  color: #007bff;\n  border-bottom-color: #007bff;\n}\n\n.assign-reviewers-tab,\n.add-review-tab,\n.review-history-tab {\n  padding: 24px;\n}\n\n.reviewer-item {\n  padding: 16px;\n  margin-bottom: 12px;\n  border-radius: 8px;\n  border: 1px solid #eee;\n  background-color: white;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.reviewer-item:hover {\n  background-color: #f0f7ff;\n  border-color: #d0e8ff;\n}\n\n.reviewer-item.selected {\n  background-color: #e6f7ff;\n  border: 1px solid #91d5ff;\n}\n\n.reviewer-avatar {\n  font-size: 1.5rem;\n  margin-right: 16px;\n}\n\n.reviewer-info {\n  flex: 1;\n}\n\n.reviewer-name {\n  font-weight: 500;\n  font-size: 1rem;\n}\n\n.reviewer-role,\n.reviewer-email {\n  font-size: 0.8rem;\n  color: #666;\n}\n\n.review-form .form-group {\n  margin-bottom: 16px;\n}\n\n.review-form label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n}\n\n.review-item {\n  padding: 16px;\n  margin-bottom: 16px;\n  border-radius: 8px;\n  border: 1px solid #eee;\n  background-color: white;\n  border-left-width: 4px;\n}\n\n.review-header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.reviewer-info {\n  display: flex;\n  align-items: center;\n}\n\n.review-date {\n  font-size: 0.8rem;\n  color: #666;\n}\n\n.review-status {\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-weight: 500;\n  font-size: 0.8rem;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.review-comments {\n  font-size: 0.9rem;\n  line-height: 1.5;\n}\n\n.update-options {\n  margin-bottom: 24px;\n}\n\n.form-group {\n  margin-bottom: 16px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n}\n\ntextarea {\n  width: 100%;\n  padding: 12px;\n  border-radius: 6px;\n  border: 1px solid #ddd;\n  min-height: 80px;\n  font-size: 0.9rem;\n  resize: vertical;\n}\n\n/* Animation for loading spinner */\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
